/**
 * @generated SignedSource<<4656e72e6619097cb58fad64154a11d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AutoRecordRulesListItemRuleDescriptionTooltips$data = {
  readonly emailDomainList: ReadonlyArray<string>;
  readonly " $fragmentType": "AutoRecordRulesListItemRuleDescriptionTooltips";
};
export type AutoRecordRulesListItemRuleDescriptionTooltips$key = {
  readonly " $data"?: AutoRecordRulesListItemRuleDescriptionTooltips$data;
  readonly " $fragmentSpreads": FragmentRefs<"AutoRecordRulesListItemRuleDescriptionTooltips">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AutoRecordRulesListItemRuleDescriptionTooltips",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailDomainList",
      "storageKey": null
    }
  ],
  "type": "Account",
  "abstractKey": null
};

(node as any).hash = "79067272ab5d33ed3bf77252ac875992";

export default node;
